import React, { FunctionComponent } from 'react'
import { QuickKeyNodeType } from '../../../quick-keys/qk.constants'
import {
  QuickKeyBlank,
  QuickKeyFolder,
  QuickKeyKey,
} from '../../../quick-keys/qk-types'
import { QKKey } from './QKKey'
import { QKFolder } from './QKFolder'

interface NodeProps {
  quickKey: QuickKeyFolder | QuickKeyBlank | QuickKeyKey | null
  isFocussed?: boolean
  setFocus: (qk: QuickKeyFolder | QuickKeyKey) => void
  selectQuickKey: (qk: QuickKeyFolder | QuickKeyKey) => void
}

export const QKNode: FunctionComponent<NodeProps> = ({
  quickKey,
  isFocussed,
  setFocus,
  selectQuickKey,
}) => {
  if (!quickKey) {
    return null
  }

  switch (quickKey.type) {
    case QuickKeyNodeType.FOLDER:
      return (
        <QKFolder
          quickKey={quickKey}
          isFocussed={isFocussed}
          onClick={selectQuickKey}
          setFocus={setFocus}
        />
      )
    case QuickKeyNodeType.QUICK_KEY:
      return (
        <QKKey
          quickKey={quickKey}
          isFocussed={isFocussed}
          setFocus={setFocus}
          onClick={selectQuickKey}
        />
      )
    case QuickKeyNodeType.BLANK:
      return <div className="vd-quick-key vd-quick-key--blank" />
    default:
      return null
  }
}
